export const DEFAULT_SLIPPAGE_PERCENTAGE = '10';
